'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterBarProps {
  onFilterChange: (filters: FilterState) => void;
}

export interface FilterState {
  guestType: string;
  apartmentType: string;
  rating: string;
}

export default function FilterBar({ onFilterChange }: FilterBarProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [filters, setFilters] = useState<FilterState>({
    guestType: 'all',
    apartmentType: 'all',
    rating: 'all'
  });

  useState(() => {
    setIsHydrated(true);
  });

  const handleFilterChange = (key: keyof FilterState, value: string) => {
    if (!isHydrated) return;
    
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const guestTypes = [
    { value: 'all', label: 'All Guests' },
    { value: 'business', label: 'Business Travelers' },
    { value: 'extended', label: 'Extended Stay' },
    { value: 'leisure', label: 'Leisure Travelers' },
    { value: 'corporate', label: 'Corporate Groups' }
  ];

  const apartmentTypes = [
    { value: 'all', label: 'All Apartments' },
    { value: 'luxos', label: 'Luxos Luxury' },
    { value: 'classica', label: 'Classica Comfort' }
  ];

  const ratings = [
    { value: 'all', label: 'All Ratings' },
    { value: '5', label: '5 Stars' },
    { value: '4', label: '4+ Stars' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-subtle p-6 border border-border mb-8">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="FunnelIcon" size={20} className="text-accent" />
        <h3 className="font-semibold text-text-primary">Filter Stories</h3>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            Guest Type
          </label>
          <select
            value={filters.guestType}
            onChange={(e) => handleFilterChange('guestType', e.target.value)}
            className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 bg-white text-text-primary"
          >
            {guestTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            Apartment Type
          </label>
          <select
            value={filters.apartmentType}
            onChange={(e) => handleFilterChange('apartmentType', e.target.value)}
            className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 bg-white text-text-primary"
          >
            {apartmentTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            Rating
          </label>
          <select
            value={filters.rating}
            onChange={(e) => handleFilterChange('rating', e.target.value)}
            className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-accent focus:border-accent transition-all duration-300 bg-white text-text-primary"
          >
            {ratings.map((rating) => (
              <option key={rating.value} value={rating.value}>
                {rating.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}